import React, { useReducer, useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

import ListCard from './ListCard';
import ListScreen from './ListScreen';
import Modals from './Modals';

const formReducer = (curForm, action) => {
	switch (action.type) {
		case 'RESET':
			return { name: '', description: '' };
		case 'FILL':
			return action.payload;
		default:
			return { ...curForm, [action.name]: action.value };
	}
};

const FollowingTab = ({ followsLists, listDispatch, api }) => {
	const [modalState, setModalState] = useState('');
	const [currentId, setCurrentId] = useState('');
	const [showList, setShowList] = useState(null);
	const [formData, formDispatch] = useReducer(formReducer, { name: '' });

	const createList = async () => {
		setModalState(false);
		try {
			const data = await api.createList(formData);
			// add these to maintain state for eg dashboard_tab without having to fetch again
			formData.articles = [];
			formData.organizations = [];
			formData.id = data.id;
			listDispatch({ type: 'CREATE', payload: formData });
			formDispatch({ type: 'RESET' });
		} catch (error) {
			console.error(error);
		}
	};

	const deleteList = async (id) => {
		setModalState('');
		setCurrentId('');
		try {
			const { data } = await api.deleteList(id);
			listDispatch({ type: 'DELETE', payload: id });
			if (showList && showList.id == id) {
				setShowList(null);
			}
		} catch (error) {
			console.error(error);
		}
	};

	const editList = async (id) => {
		setModalState('');
		setCurrentId('');
		try {
			const data = await api.editList(id, formData);
			listDispatch({ type: 'UPDATE', payload: data });
			if (showList && showList.id == id) {
				setShowList(data);
			}
		} catch (error) {
			console.error(error);
		}
	};

	const handleFormChange = (event) => {
		formDispatch({
			type: null,
			name: event.target.name,
			value: event.target.value,
		});
	};

	return (
		<div id="following-tab">
			<div style={showList ? { display: 'none' } : {}}>
				<div className="row">
					<div className="column small-9">
						<h2>My lists</h2>
						<span>
							Create a list of specific organizations and articles
							around a project, a topic or for inspiration.
						</span>
					</div>
					<div className="column small-3">
						<div
							className="primary-button new-list-button"
							onClick={() => setModalState('new')}
						>
							<p>
								<FontAwesomeIcon icon={faPlus} /> New list
							</p>
						</div>
					</div>
				</div>
				<div className="row card-holder">
					{followsLists.map((followList, index) => {
						return (
							<ListCard
								followList={followList}
								setCurrentId={setCurrentId}
								setModalState={setModalState}
								setShowList={setShowList}
								formDispatch={formDispatch}
								key={index}
							/>
						);
					})}
				</div>
			</div>
			<Modals
				modalState={modalState}
				setModalState={setModalState}
				formData={formData}
				handleFormChange={handleFormChange}
				createList={createList}
				currentId={currentId}
				editList={editList}
				deleteList={deleteList}
			/>
			<ListScreen
				followList={showList}
				setShowList={setShowList}
				setCurrentId={setCurrentId}
				setModalState={setModalState}
				formDispatch={formDispatch}
			/>
		</div>
	);
};

export default FollowingTab;
